import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  BalanceQuery,
  Barcode,
  BarcodeQuery,
  BarcodeService,
  config,
  MemberCard,
  MemberCardQuery,
  MemberDetails,
  MemberQuery,
  SeatingDetail,
  SeatingDetailQuery,
} from '@fgb/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { firstValueFrom, Observable } from 'rxjs';

@Component({
  selector: 'fgb-barcode',
  templateUrl: './barcode.component.html',
  styleUrls: ['./barcode.component.scss'],
})
export class BarcodeComponent implements OnInit {
  @Input() memberId: string;
  @Input() jetsCashDesign: boolean;
  @Input() showMobilePass?: boolean;
  @Input() isHomePage: boolean = false;
  @Input() isWalletPage: boolean = false;

  @Output() openAddNewCard = new EventEmitter<null>();

  barcode$: Observable<Barcode>;
  pointsBalance$: Observable<number | undefined>;
  member$: Observable<MemberDetails | undefined>;
  ecashBalance$: Observable<number | undefined>;
  card$: Observable<MemberCard | undefined>;
  seatingDetail$: Observable<SeatingDetail | undefined>;

  constructor(
    private barcodeService: BarcodeService,
    private barcodeQuery: BarcodeQuery,
    private balanceQuery: BalanceQuery,
    private memberCardQuery: MemberCardQuery,
    private memberDetailsQuery: MemberQuery,
    private modalService: NgbModal,
    private seatingDetailQuery: SeatingDetailQuery
  ) {}

  ngOnInit() {
    firstValueFrom(this.barcodeService.fetchBarcode());
    this.barcode$ = this.barcodeQuery.select();
    this.member$ = this.memberDetailsQuery.selectMemberDetails();
    this.seatingDetail$ = this.seatingDetailQuery.selectCurrentSeatingDetails();
    this.pointsBalance$ = this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty);
    this.ecashBalance$ = this.balanceQuery.selectPurse(config.purseConfig.combined);
    this.card$ = this.memberCardQuery.selectCurrentCard();
  }

  open(content: any) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
  }

  close() {
    this.modalService.dismissAll();
  }
}
